import { WrapperCard } from './card.styled'

const Card = (props) => {
  return <WrapperCard>{props.children}</WrapperCard>
}

export default Card
